export default {
  index: [
    {
      path: '/myqccmanager',
      component: resolve => require(['./qccmanagerIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/myqccmanager/_router.js